import { useCallback, useState } from 'react'
import { ReactState, StateSetter, StateSetterAction } from '../Types/Types'
import { $SessionStorage } from '../../../NonReact/utils/SessionStorageUtils'

export function useSessionState<T>(key: string, initialValue: T): ReactState<T> {
    const [state, setState]: ReactState<T> = useState<T>((): T => $SessionStorage.getItem<T>(key) ?? initialValue)

    const setStateAndSessionStorage: StateSetter<T> = useCallback(
        (value: StateSetterAction<T>): void => {
            setState(value)

            if (typeof value === 'function') {
                $SessionStorage.setItem(key, (value as (prevState: T) => T)(state))
            } else {
                $SessionStorage.setItem(key, value)
            }
        },
        [key, state]
    )

    return [state, setStateAndSessionStorage]
}
